import React, { useEffect } from 'react'
import { Form, Input, Select } from 'antd'

import './AddonAfterField.scss'

const AddonAfterField = ({
  label,
  name,
  placeholder,
  required,
  rules,
  initialValue,
  value,
  type,
  afteFieldOptions,
  defaultAfterFieldValue,
  onChange,
  afterFieldName,
  form,
}) => {
  const selectAfter = (
    <Select defaultValue={defaultAfterFieldValue} onChange={onChange}>
      {afteFieldOptions?.map((item) => {
        return (
          <Select.Option value={item?.value} key={item?.value}>
            {item?.label}
          </Select.Option>
        )
      })}
    </Select>
  )

  useEffect(() => {
    if (form && typeof form.setFieldValue === 'function') {
      form.setFieldValue(afterFieldName, defaultAfterFieldValue)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultAfterFieldValue])

  return (
    <>
      <Form.Item
        className="text-field add-on-field"
        label={label}
        required={required}
        name={name}
        rules={rules}
        initialValue={initialValue}
      >
        <Input
          type={type}
          value={value}
          placeholder={placeholder}
          addonAfter={selectAfter}
        />
      </Form.Item>
      <Form.Item className="after-field" name={afterFieldName} />
    </>
  )
}

export default AddonAfterField
